import React from 'react';
import UsersContainer from '../../Containers/UsersContainer';


export const InactiveUsers = (props) => {
	return (
		<UsersContainer show="inactiveUsers"/>
	);
}

export default InactiveUsers;